import { ConnectProto } from "@racoon/api";
import { getEnumName } from "@racoon/lib";
import { scheduledJobTypes } from "./container-group-schedule";

/** Legacy tariff maps key by enum number ("10") or unprefixed name ("MSW"); normalize to "JOB_TYPE_*". */
export const normalizeJobTypeKey = (key: string): string => {
  if (!Number.isNaN(Number(key))) {
    // getEnumName returns the protobuf JSON name, which already carries the prefix.
    return getEnumName(ConnectProto.JobTypeSchema, Number(key)) ?? key;
  }
  return key.startsWith("JOB_TYPE_") ? key : `JOB_TYPE_${key}`;
};

/** Job types priced by the container group's contract (tariff_rate_by_job_type keys). */
const containerGroupContractJobTypes = (cg: ConnectProto.ContainerGroup): string[] => {
  const tariff = cg.contract?.tariffRateByJobType as Record<string, unknown> | undefined;
  if (!tariff || typeof tariff !== "object") return [];
  return Object.keys(tariff).map(normalizeJobTypeKey);
};

/** Groups whose contract prices no job type: the only ones that need their schedules for job types. */
export const unpricedContainerGroups = <T extends ConnectProto.ContainerGroup>(groups: T[]): T[] =>
  groups.filter((cg) => containerGroupContractJobTypes(cg).length === 0);

/**
 * Job types a pickup-location-group link can be created for. Mirrors the
 * backend's ContainerGroup.GetRequiredJobTypes: the contract's tariff map is
 * the source of truth, the group's schedule rows are only a fallback — so
 * container groups without a schedule are still bindable.
 */
export const containerGroupRequiredJobTypes = (
  cg: ConnectProto.ContainerGroup,
  schedules?: ConnectProto.ContainerGroupSchedule[],
): string[] => {
  const fromContract = containerGroupContractJobTypes(cg);
  return fromContract.length > 0 ? fromContract : scheduledJobTypes(schedules);
};
